import { styled } from '@mui/material/styles';

import Table from '@mui/material/Table';

const StyledTable = styled(Table)(({ theme }) => ({
    '& .MuiTableCell-root': {
        borderBottomColor: theme.palette.border.main
    }
}));

export default StyledTable;
